<!--表單-->
<template>
  <div class="dropdown offset-11">
    <!--語言列-->
    <a
      href="#"
      class="nav-link dropdown-toggle"
      data-bs-toggle="dropdown"
      role="button"
      aria-expanded="false"
      ><img src="../assets/language-24px.svg"
    /></a>
    <ul class="dropdown-menu">
      <li>
        <a @click="updateLang('zh-TW')" class="dropdown-item">繁體中文</a>
      </li>
      <li>
        <a @click="updateLang('en-US')" class="dropdown-item">English</a>
      </li>
      <li>
        <a @click="updateLang('ja-JP')" class="dropdown-item">日本語</a>
      </li>
    </ul>
  </div>
  <!--頁面切換-->
  <div
    class="card offset-lg-2 col-lg-8 offset-md-1 col-md-10 offset-sm-1 col-sm-10 offset-xs-1 col-xs-10 shadow-box"
  >
    <div v-if="formtype === 0">
      <formDescription></formDescription>
      <button class="mt-5 col-2 btn" @click="changeType(1)">
        {{ $t("start") }}
      </button>
    </div>
    <div v-if="formtype === 1" class="mt-5">
      <membercreate
        @count="countpage1"
        @change-page="changePage1"
        @form-data="getFormData1"
      ></membercreate>
    </div>
    <div v-if="formtype === 2" class="mt-5">
      <qustionVue
        @count="countpage2"
        @change-page="changePage2"
        @form-data="getFormData2"
      ></qustionVue>
    </div>
    <div v-if="formtype === 3">
      <div class="mt-5">
        <label class="md-title">{{ $t("finishForm") }}</label>
      </div>
      <div>
        <button class="mt-5 col-2 btn" @click="submit" :disabled="submitclick">
          {{ $t("submit") }}
        </button>
      </div>
    </div>
    <!--條款+logo-->
    <div class="terms">
      <p>{{ $t("termsTitle") }}<br />{{ $t("terms") }}</p>
    </div>
    <div class="mb-3">
      <img src="../assets/Tongtai_LOGO.png" style="width: 5rem; height: 4rem" />
    </div>
  </div>
  <label class="pagemagin">{{ 1 }}</label>
  <!--進度列-->
  <div class="footerbox">
    <div class="pt-3 mx-2 row">
      <div class="progress col-5 nopadding">
        <div
          class="progress-bar progress-bar-striped progress-bar-animated progress-bar-color"
          role="progressbar"
          :aria-valuenow="valuenowPage1 + valuenowPage2"
          aria-valuemin="0"
          aria-valuemax="100"
          :style="{ width: valuenowPage1 + valuenowPage2 + '%' }"
        >
          {{ valuenowPage1 + valuenowPage2 }}{{ "%" }}
        </div>
      </div>
      <!-- <div class="col-2">
        <button class="input-link-btn" @click="changeType(formtype - 1)">
          <img srv="src/assets/ChevronLeft.svg" style="color: #000" />
        </button>
      </div>
      <div class="col-2">
        <button class="input-link-btn" @click="changeType(formtype + 1)">
          <img srv="src/assets/ChevronRight.svg" />
        </button>
      </div> -->
    </div>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<script setup>
import { ref, watch } from "vue";
import formDescription from "@/components/formDescription.vue";
import membercreate from "@/components/memberCreate.vue";
import qustionVue from "@/components/qustionVue.vue";
import { useI18n } from "vue-i18n";
//import { useStore } from "vuex";
import Swal from "sweetalert2";
import axios from "axios";
import { userStore } from "../store/pinia";
const { setLoading,changeLang } = userStore();
//const store = useStore();
const { locale, t } = useI18n();
const updateLang = (languageFamily) => {
  Swal.fire({
    text: t("changeLanguage"),
    icon: "warning",
    confirmButtonText: t("confirmed"),
    showCancelButton: true,
    cancelButtonText: t("cancel"),
    cancelButtonColor: "#36B2D9",
    confirmButtonColor: "#36B2D9",
  }).then((result) => {
    if (result.isConfirmed) {
      changeLang(languageFamily);
      locale.value = languageFamily;
      window.location.reload();
    } else {
      return false;
    }
  });
};
const formtype = ref(0);
const valuenowPage1 = ref(0);
const valuenowPage2 = ref(0);
const formData = ref({});
const submitclick = ref(false);
const changeType = (type) => {
  if (type <= 0) {
    formtype.value = 0;
  } else if (type === 1) {
    formtype.value = 1;
  } else if (type === 2) {
    formtype.value = 2;
  } else if (type >= 3) {
    formtype.value = 3;
  }
  toTop();
};

const toTop = () => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
};
const countpage1 = (e) => {
  let tempCount = 0;
  valuenowPage1.value = 0;
  if (e > 0) {
    let newCount = e * 8.333333333333333;
    tempCount = Math.ceil(newCount);
  }
  valuenowPage1.value = tempCount;
};
const countpage2 = (e) => {
  let tempCount = 0;
  valuenowPage2.value = 0;
  if (e > 0) {
    let newCount = e * 8.333333333333333;
    tempCount = Math.ceil(newCount);
  }
  valuenowPage2.value = tempCount;
};
const rebackType = ref(false);
const changePage1 = (e) => {
  if (e !== rebackType.value) {
    formtype.value = 2;
    rebackType.value = !rebackType.value;
    toTop();
  }
};
const changePage2 = (e) => {
  //資料不完整要到第二頁
  if (e.type === "error") {
    alert("資料不完整要到第二頁");
    formtype.value = 2;
    toTop();
  } else {
    formtype.value = 3;
    toTop();
  }
};
const getFormData1 = (e) => {
  console.log(e);
  formData.value.name = e.name;
  formData.value.company = e.company;
  formData.value.department = e.department;
  formData.value.positionTitle = e.positionTitle;
  formData.value.companyPhone = e.companyPhone;
  formData.value.phoneNumber = e.phoneNumber;
  formData.value.email = e.email;
  formData.value.time = e.time;
  console.log(formData.value);
};
const getFormData2 = (e) => {
  console.log(e);
  formData.value.Q9 = e.Q9;
  formData.value.Q10 = e.Q10;
  formData.value.Q11 = e.Q11;
  formData.value.Q12 = e.Q12;
  formData.value.Q13 = e.Q13;
  formData.value.Q14 = e.Q14;
  formData.value.Q15 = e.Q15;
  console.log(formData.value);
};
const submit = () => {
  if (
    formData.value.name !== "" &&
    formData.value.company !== "" &&
    formData.value.positionTitle !== "" &&
    formData.value.companyPhone !== "" &&
    formData.value.phoneNumber !== "" &&
    formData.value.email !== "" &&
    formData.value.Q9[0] !== "" &&
    formData.value.Q11 !== "" &&
    formData.value.Q12 !== "" &&
    formData.value.Q13 !== "" &&
    formData.value.Q14 !== "" &&
    formData.value.Q15[0] !== ""
  ) {
    //api
    console.log("送出資料", [
      { idx: "1", answer: formData.value.name },
      { idx: "2", answer: formData.value.company },
      { idx: "3", answer: formData.value.department },
      { idx: "4", answer: formData.value.positionTitle },
      { idx: "5", answer: formData.value.companyPhone },
      { idx: "6", answer: formData.value.phoneNumber },
      { idx: "7", answer: formData.value.email },
      { idx: "8", answer: formData.value.time },
      { idx: "9", answer: formData.value.Q9 },
      { idx: "10", answer: formData.value.Q10 },
      { idx: "11", answer: formData.value.Q11 },
      { idx: "12", answer: formData.value.Q12 },
      { idx: "13", answer: formData.value.Q13 },
      { idx: "14", answer: formData.value.Q14 },
      { idx: "15", answer: formData.value.Q15 },
    ]);
    submitclick.value = true;
    /**loading開啟 */
    setLoading(true);
    axios({
      method: "POST",
      url: "/consult/drtt",
      headers: {},
      data: [
        { idx: "1", answer: formData.value.name },
        { idx: "2", answer: formData.value.company },
        { idx: "3", answer: formData.value.department },
        { idx: "4", answer: formData.value.positionTitle },
        { idx: "5", answer: formData.value.companyPhone },
        { idx: "6", answer: formData.value.phoneNumber },
        { idx: "7", answer: formData.value.email },
        { idx: "8", answer: formData.value.time },
        { idx: "9", answer: formData.value.Q9 },
        { idx: "10", answer: formData.value.Q10 },
        { idx: "11", answer: formData.value.Q11 },
        { idx: "12", answer: formData.value.Q12 },
        { idx: "13", answer: formData.value.Q13 },
        { idx: "14", answer: formData.value.Q14 },
        { idx: "15", answer: formData.value.Q15 },
      ],
    })
      .then((e) => {
        console.log(e);
        /**loading關閉 */
        setLoading(false);
        if (e.data.status === true) {
          Swal.fire({
            icon: "success",
            text: t("_formSuccess"),
            confirmButtonColor: "#36b2d9",
            showConfirmButton: true,
            allowOutsideClick: false,
            confirmButtonText: t("confirmed"),
          }).then((e) => {
            if (e.isConfirmed === true) {
              window.location.reload();
            }
          });
        } else {
          submitclick.value = false;
          Swal.fire({
            icon: "error",
            text: e.data.errors.message,
            confirmButtonText: t("confirmed"),
            confirmButtonColor: "#36b2d9",
            showConfirmButton: true,
          });
        }
      })
      .catch((err) => {
        /**loading關閉 */
        setLoading(false);
        console.log(err);
        submitclick.value = false;
        Swal.fire({
          icon: "error",
          text: "error",
          confirmButtonText: t("confirm"),
          confirmButtonColor: "#36b2d9",
          showConfirmButton: true,
        });
      });
  } else {
    alert("未填完整");
  }
};
watch(formData, (newform) => {
  formData.value = newform;
});
watch(formtype, (newtype) => {
  if (newtype === 1 || newtype === 0) {
    valuenowPage1.value = 0;
    valuenowPage2.value = 0;
  }
  if (newtype === 2) {
    valuenowPage2.value = 0;
  }
});
// watch(formData, (newdata) => {

// });
//**頁面重置*/
//關閉頁面/重置事件監聽
//window.addEventListener("beforeunload", alertData('warning',t('closeViewAlert')));
// window.removeEventListener("beforeunload", alertData('warning',t('closeViewAlert')));
//window.addEventListener("load", () => alert('123'));
</script>
